<script lang="ts">
  import Caret from "~icons/ph/caret-down";
</script>

<details>
  <summary>When will I receive payment?<Caret /></summary>
  <p>
    Once you have provided us with your bank details and we have received approval from your bank that your details
    match, you should have the money within one week.
  </p>
</details>
